"use client"

import Link from 'next/link'
import { getAllPublishedPosts, getLabels } from '@/app/adapters/api';
import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import Image from 'next/image';
import { useSelector } from 'react-redux';
import { selectLanguage } from '@/app/redux/store';
import Label from '../label/Label';

const labelsNames = [
  "blog-title",
];

export default function LatestPosts() {
    const [data, setData] = useState<any>([]);
    const lang = useSelector(selectLanguage)
    const [labels, setLabels] = useState<any>({});

    useEffect(() => {
        getLabels(labelsNames)
        .then((response: any) => {
            setLabels(response.data.labels);
        })
      .finally(() => { });
        getAllPublishedPosts(0, 3, '', [])
            .then((response) => {
                setData(response.data.posts)
            })

    }, []);

    return (
        <>
            <div className='flex flex-col items-center justify-center mb-16'>
                <div className='text-2xl sm:text-3xl md:text-4xl font-semibold text-orange-custom mt-12'>
                    <Label label={labels.blogTitle} lang={lang} />
                </div>
                <div className="flex justify-center items-start flex-wrap gap-12 h-auto mt-16 px-8 pb-16 gap-y-6" >

                    {data && data.length > 0 ? (
                    data.map((post: any, index: number) => (
                    <Link href={`https://blog.bolsasocial.com/${new Date(post.date).toISOString().slice(0, 10).replace(/-/g, '/')}/`} key={index} >
                        <div className="w-[330px] pt-4 pb-8 border-b sm:border-b-0 border-gray-500">
                            <div className="w-full h-[180px] relative">
                            <Image
                                src={post.pictureUrl.replace('/blog/', '/back/')}
                                alt="imagen"
                                layout="fill"
                                objectFit="cover"
                                className="absolute z-4 rounded-[20px]"
                            />
                            {!post?.active ? (
                                <div className="absolute z-5 p-[5px] rounded top-[-10px] right-[-10px] bg-red-500 text-white text-sm">
                                Borrador
                                </div>
                            ) : null}
                            </div>
                            {post.title ? (
                            <h2
                                className="text-3xl my-4 font-bold"
                                dangerouslySetInnerHTML={{
                                __html:
                                    post?.title.length > 60
                                    ? post?.title.substring(0, 60) + "..."
                                    : post?.title,
                                }}
                            ></h2>
                            ) : null}
                            {post.esDescription ? (
                            <p
                                className="tex-2xl"
                                dangerouslySetInnerHTML={{
                                __html:
                                    post?.esDescription.length > 120
                                    ? post?.esDescription.substring(0, 120) + " [...]"
                                    : post?.esDescription,
                                }}
                            ></p>
                            ) : null}
                            <p className="text-primary mt-4">
                            {lang === 'en' ? 'READ MORE' : 'LEER MÁS'}
                            </p>
                        </div>
                        </Link>
                    ))
                    ) : null}
                </div>
                <Link href='/blog'>
                    <Button variant={'default'} className='px-12 rounded-3xl'>
                        { lang === 'en' ? 'VISIT OUR BLOG': 'VISITA NUESTRO BLOG'}
                    </Button>
                </Link>
            </div>
        </>
    )
}
